(function () {
  'use strict';

  angular.module('ringbaPortal').filter('notInCampaignRoutes', notInCampaignRoutes);

  function notInCampaignRoutes(_) {
    return function (targets, routes, type) {
      const filtered = [];
      type = type || 'target';
      switch (type) {
      case 'target': {
        _.forEach(targets, function (target) {
          if (targets && routes) {
            if (!_.find(routes, { callTarget: { id: target.id } })) {
              filtered.push(target);
            }
          } else {
            filtered.push(target);
          }
        });
        break;
      }
      case 'group': {
        _.forEach(targets, function (target) {
          if (targets && routes) {
            if (!_.find(routes, { callTargetGroup: { id: target.id } })) {
              filtered.push(target);
            }
          } else {
            filtered.push(target);
          }
        });
        break;
      }
      case 'pingTree': {
        _.forEach(targets, function (target) {
          if (targets && routes) {
            if (!_.find(routes, { callPingTree: { id: target.id } })) {
              filtered.push(target);
            }
          } else {
            filtered.push(target);
          }
        });
        break;
      }

      }
      return filtered;
    };
  }
})();
